// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout .left .companyInfo {
    border-bottom: 1px solid #dedede;
    border-top: 1px solid #dedede;
    padding-left: 13px;
    padding-right: 5px;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    align-items: center;
    align-content: space-around;
    color: #dedede;
    background-color: #273643;
}

.layout .left .companyInfo .avatar {
    width: 25%;
    border-radius: 50%;
}

.layout .left .companyInfo .avatar img {
    border-radius: 50%;
    width: 53px;
    border: 2px solid #dedede;
    background-color: #fff;
}

.layout .left .companyInfo .infos {
    width: 75%;
    padding-left: 15px;
    margin-top: 10px;
}

.layout .left .companyInfo .infos .nameSurname {
    font-size: 14px;
    font-weight: bold;
    color: white;
}

.layout .left .companyInfo .infos .companyName {
    font-size: 12px;
    font-weight: 600;
    color: white;
}

.layout a:link {
    text-decoration: none;
}

.layout .ant-menu-item-selected {
    background-color: #1677ff;
    border-radius: 0 !important;
}

.trigger {

    font-size: 18px;
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
}

.ant-menu-title-content>a {
    color: hsl(0, 0%, 90%) !important;
    text-decoration: none;
}

#FIXED_CONTAINER_ID>div {
    z-index: 999999 !important;
}

.ant-spin-fullscreen-show {
    z-index: 999999 !important;
}

.cardSelect {
    box-shadow: 0 0 10px -2px rgb(0 0 0 / 20%);
    border-radius: 5px;
    transition: transform .2s;
    cursor: pointer;
}

.cardSelect:hover {
    transform: scale(1.1);
}

.cardSelected {
    box-shadow: 0 0 10px -2px rgb(0 0 0 / 40%);
    border-radius: 5px;
    transition: transform .2s;
    border: 3px solid #41009a !important;
    cursor: pointer;
    transform: scale(1.2);
    z-index: 99;
}


.ant-table-header col {
    min-width: 120px;
}

.ant-table-body td {
    min-width: 120px;

}

.ant-table-body td:first-child,
.ant-table-body td:nth-child(2) {
    min-width: 40px;

}

.ant-table-header col:first-child,
.ant-table-header col:nth-child(2) {
    min-width: 40px;
}

.listingManifest {
    margin-bottom: 3px;
    border: 1px solid #ccc;
    padding-top: 3px;
    padding-bottom: 3px;
    background-color: #f9f9f9;
    border-radius: 0px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
}

svg {
    vertical-align: baseline !important;
}

.showHidePassword {
    position: absolute;
    top: 14px;
    right: 15px;
    cursor: pointer;
}

.loginPage .or {
    border-bottom: 1px solid #e8e8e8;
    line-height: .1em;
    margin: 15px 0;
    text-align: center
}

.loginPage .or span {
    background: #fff;
    color: #999;
    padding: 0 10px
}

.layouts .title {
    width: 100%;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.layouts .company {
    width: 100%;
    font-size: 11px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}

/* ============================================
   BONUS / KHG LAYOUT THEME
   ============================================ */

:root {
    --bonus-gold: #c8a96a;
    --bonus-gold-light: #e0c48a;
    --bonus-gold-dark: #a8884a;
    --bonus-ink: #1f2937;
    --bonus-ink-soft: #4b5563;
    --bonus-bg: #f7f5f0;
}

.bonus-shell {
    background: var(--bonus-bg) !important;
    font-family: 'Roboto', system-ui, -apple-system, sans-serif;
}

/* ---- Sider ---- */
.bonus-sider {
    background: linear-gradient(180deg, #0f1620 0%, #0b1018 100%) !important;
    box-shadow: 4px 0 24px rgba(15, 22, 32, 0.06);
}

.bonus-sider .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
}

.bonus-sider-logo {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 22px 18px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    position: relative;
}

.bonus-sider-logo::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 18px;
    right: 18px;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(200, 169, 106, 0.35), transparent);
}

.bonus-sider-logo.collapsed {
    padding: 22px 0 20px;
    justify-content: center;
}

.bonus-sider-logo-mark {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 11px;
    background: #fff;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(200, 169, 106, 0.4);
}

.bonus-sider-logo-mark img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.bonus-sider-logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.05;
}

.bonus-sider-logo-title {
    font-size: 22px;
    font-weight: 700;
    background: linear-gradient(90deg, #fff, #e0c48a);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: 0.5px;
}

.bonus-sider-logo-sub {
    font-size: 10.5px;
    color: var(--bonus-gold-light);
    text-transform: uppercase;
    letter-spacing: 1.5px;
    margin-top: 4px;
    opacity: 0.8;
}

/* User info card */
.layouts .companyInfo,
.bonus-sider-user {
    background: rgba(255, 255, 255, 0.03) !important;
    border: 1px solid rgba(255, 255, 255, 0.06) !important;
    border-radius: 12px !important;
    margin: 16px 14px 12px !important;
    padding: 12px !important;
    color: rgba(255, 255, 255, 0.88) !important;
    display: flex;
    align-items: center;
}

.bonus-sider-avatar {
    background: linear-gradient(135deg, var(--bonus-gold), var(--bonus-gold-dark)) !important;
    box-shadow: 0 4px 12px rgba(200, 169, 106, 0.3);
}

.bonus-sider-user-name {
    font-size: 13.5px !important;
    color: #fff !important;
}

.bonus-sider-user-meta {
    font-size: 11px !important;
    color: rgba(255, 255, 255, 0.55) !important;
    font-weight: 500 !important;
}

/* Status badge */
.bonus-sider-status {
    margin: 0 14px 16px;
}

.bonus-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 999px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.4px;
}

.bonus-status-badge .dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    box-shadow: 0 0 0 3px currentColor;
    opacity: 0.25;
}

.bonus-status-badge.approved {
    background: rgba(200, 169, 106, 0.14);
    color: var(--bonus-gold-light);
    border: 1px solid rgba(200, 169, 106, 0.3);
}

.bonus-status-badge.approved .dot {
    background: var(--bonus-gold);
    color: var(--bonus-gold);
}

.bonus-status-badge.pending {
    background: rgba(250, 204, 21, 0.1);
    color: #facc15;
    border: 1px solid rgba(250, 204, 21, 0.3);
}

.bonus-status-badge.pending .dot {
    background: #facc15;
    color: #facc15;
}

/* Menu */
.bonus-sider-menu {
    border-inline-end: 0 !important;
    padding: 6px 10px !important;
    background: transparent !important;
    flex: 1 1;
}

.bonus-sider-menu .ant-menu-item,
.bonus-sider-menu .ant-menu-submenu-title {
    border-radius: 10px !important;
    margin: 4px 0 !important;
    height: 42px !important;
    line-height: 42px !important;
    font-size: 13.5px;
    font-weight: 500;
}

.bonus-sider-menu .ant-menu-item-selected {
    background: linear-gradient(90deg, rgba(200, 169, 106, 0.22), rgba(200, 169, 106, 0.08)) !important;
    border-left: 2px solid var(--bonus-gold);
    padding-left: calc(24px - 2px) !important;
}

.bonus-sider-menu .ant-menu-item-selected .ant-menu-title-content > a,
.bonus-sider-menu .ant-menu-item-selected .ant-menu-title-content {
    color: var(--bonus-gold-light) !important;
    font-weight: 600;
}

.bonus-sider-menu .ant-menu-item .anticon,
.bonus-sider-menu .ant-menu-submenu-title .anticon {
    font-size: 16px !important;
}

.layouts .ant-menu-item-selected {
    background-color: transparent;
}

.ant-menu-title-content > a {
    color: rgba(255, 255, 255, 0.78) !important;
}

.bonus-sider-menu .ant-menu-item:hover .ant-menu-title-content > a {
    color: #fff !important;
}

/* ---- Header ---- */
.bonus-header {
    padding: 0 24px !important;
    background: #fff !important;
    height: 68px !important;
    line-height: 68px !important;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid #ece8dd;
    box-shadow: 0 2px 12px rgba(31, 41, 55, 0.04);
    position: relative;
}

.bonus-header::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(200, 169, 106, 0.45), transparent);
}

.bonus-header-search {
    flex: 1 1;
    max-width: 480px;
    background: #f7f5f0;
    border-radius: 999px;
    padding: 0 8px 0 14px;
    height: 42px;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    transition: all 0.2s ease;
}

.bonus-header-search:focus-within {
    border-color: var(--bonus-gold);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(200, 169, 106, 0.15);
}

.bonus-header-search-input.ant-input,
.bonus-header-search-input .ant-input {
    background: transparent !important;
    font-size: 13.5px;
    line-height: 1;
}

.bonus-header-actions {
    display: flex;
    align-items: center;
    gap: 14px;
}

.bonus-header-icon-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #f7f5f0;
    border: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.bonus-header-icon-btn:hover {
    background: #ece8dd;
}

.bonus-header-divider {
    width: 1px;
    height: 28px;
    background: #ece8dd;
}

.bonus-header-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 10px 4px 4px;
    border-radius: 999px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.bonus-header-user:hover {
    background: #f7f5f0;
}

.bonus-header-avatar {
    background: linear-gradient(135deg, var(--bonus-gold), var(--bonus-gold-dark)) !important;
}

.bonus-header-user-text {
    display: flex;
    flex-direction: column;
    line-height: 1.15;
}

.bonus-header-user-text strong {
    font-size: 13px;
    color: var(--bonus-ink);
    font-weight: 600;
}

.bonus-header-user-text small {
    font-size: 11px;
    color: var(--bonus-ink-soft);
}

@media (max-width: 575.98px) {
    .bonus-header {
        padding: 0 14px !important;
    }
    .bonus-header-search {
        display: none;
    }
    .bonus-header-user-text {
        display: none;
    }
}

/* ---- Content ---- */
.bonus-content {
    margin: 24px !important;
    padding: 28px !important;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(31, 41, 55, 0.04);
    min-height: calc(100vh - 68px - 56px - 48px);
}

@media (max-width: 575.98px) {
    .bonus-content {
        margin: 12px !important;
        padding: 16px !important;
        border-radius: 10px;
    }
}

/* ---- Footer ---- */
.bonus-footer {
    text-align: center !important;
    padding: 16px 24px !important;
    color: var(--bonus-ink-soft) !important;
    background: var(--bonus-bg) !important;
    font-size: 12.5px;
}

.bonus-footer strong {
    color: var(--bonus-gold-dark);
    font-weight: 700;
    letter-spacing: 0.5px;
}

/* Sider trigger (collapse button) */
.bonus-sider .ant-layout-sider-trigger {
    background: #0a1119 !important;
    color: var(--bonus-gold) !important;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.ant-layout-sider-zero-width-trigger {
    background: var(--bonus-ink) !important;
    color: var(--bonus-gold) !important;
}
/*
.ant-slider-horizontal .ant-slider-step {
    height: 15px !important;
    inset-inline-start: 0;
    top: 15px;
    width: 100%
}

.ant-slider-horizontal {
    height: 50px !important;
    padding-block: 4px
}

.ant-slider .ant-slider-handle:active:after,
.ant-slider .ant-slider-handle:focus:after,
.ant-slider-handle:hover:after {
    box-shadow: 0 0 0 4px #410099 !important;
    height: 25px !important;
    width: 25px !important;
}

.ant-slider .ant-slider-handle:after {
    box-shadow: 0 0 0 4px #410099 !important
}

.ant-slider-dot-active {
    border-color: #410099 !important
}

.ant-slider .ant-slider-handle:after,
.ant-slider-handle:before {
    height: 25px !important;
    width: 25px !important
}

.ant-slider-handle:before {
    background-color: initial;
    content: "";
    inset-block-start: -2px;
    inset-inline-start: -2px;
    position: absolute
}

.ant-slider-horizontal .ant-slider-mark {
    inset-inline-start: 0;
    top: 30px !important;
    width: 100%
}

.ant-slider-handle {
    height: 25px !important;
    outline: none;
    position: absolute;
    width: 25px !important
}
*/

.appstore .ant-tabs-tab {
    padding-left: 0 !important;

}

.ant-layout-sider-zero-width-trigger {
    top: 12px !important;
    ;
}

.ant-tabs .ant-tabs-tab-btn {
    font-weight: bold;
}


.ant-collapse-item-disabled>.ant-collapse-header {
    cursor: default !important;
}

/*wizard step*/

.steps .stepsLabel {
    border-bottom: 1px solid #dedede;
    color: #1a335399;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 15px;
    margin-top: 15px;
    padding: 12px 15px;
    text-transform: uppercase
}

.steps ul {
    list-style-type: none;
    padding-left: 20px
}

.steps ul li {
    -webkit-font-smoothing: antialiased;
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    height: 40px;
    padding-bottom: 4px;
    padding-left: 15px;
    padding-top: 4px;
    position: relative;
    text-rendering: optimizeLegibility
}

.steps ul li.actives {
    background-color: #4100991a !important;
    border-left: 3px solid #410099;
    color: #410099 !important;
    text-decoration: none
}

.steps ul li.completes {
    color: #333 !important;
    text-decoration: none
}

.steps ul li.completes:after {
    color: #410099 !important;
    content: "✓";
    position: absolute;
    right: 15px
}

.steps ul li.passive {
    color: #a1a1a1;
    text-decoration: line-through
}

.products {
    align-items: center;
    display: flex
}

.products .img {

    padding-right: 15px
}

.products .img img {
    border-radius: 5px;
    height: 100%;
    object-fit: cover;
    width: 120px
}

.products .prog {
    padding-left: 15px
}

.products .detail {
    border-left: 1px solid #dedede;
    margin-left: 15px;
    padding-left: 15px
}

.products .detail .categories {
    margin-bottom: 5px
}

.products .detail .recordDate {
    color: #999;
    font-size: 12px
}


.inputButtonSet {
    display: flex;
    position: absolute;
    right: 0;
    height: 58px;
    top: 0;

    align-items: center;


}

.inputButtonSet>div {
    padding-left: 15px;
    padding-right: 15px;
    height: 58px;
    align-items: center;
    display: flex;
    background-color: #40009a15;
    cursor: pointer;
}

.inputButtonSet>div:hover {
    background-color: #40009a41;
}

.inputButtonSet>div:last-child {
    border-left: 1px solid #dedede;
    border-bottom-right-radius: 7px;
    border-top-right-radius: 7px;
}

/**/
.ant-tree {
    background-color: transparent;
}

.dotArea {
    position: relative;
    border: 2px dashed #dedede;
    padding: 20px 20px 20px 20px;
    background-color: #0505050f;
    border-radius: 7px;
    min-height: 56px;
}

.autocompleteContainer li:first-child {
    border-top: 0;
    border-radius: 0;

}

.autocompleteContainer li:last-child {
    border-bottom: 0;
    border-radius: 0;
}

.autocompleteContainer li {
    border-left: 0;
    border-right: 0;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.autocompleteContainer li span::before {
    content: '◉';
    margin-right: 5px;

}

.autocompleteContainer li .noResult {
    content: '';
    color: #ff0000;
    margin-right: 5px;

}

.autocompleteContainer li .noResult::before {

    content: '';
    color: #ff0000;
    margin-right: 5px;

}

.autocompleteContainer li:hover {
    background-color: #f2f2f2;
    cursor: pointer;
}


.itineraryCardHeader {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
}

.itineraryBorderBottom {
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 15px;
    margin-bottom: 15px;
}


.itineraryCardBody {
    padding: 20px
}

.timeline {
    position: relative;
    margin: 0;
    padding: 0;
    list-style: none;
}

.timeline .list-group-item+.list-group-item {
    border-top-width: 1px !important;
}

.timeline .listing {
    position: relative;
    margin-left: 20px;
    border: 1px solid #f2f2f2;
    background-color: #f9f9f9;
    border-radius: 7px;
    padding: 15px;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 3%), 0 1px 6px -1px rgb(0 0 0 / 2%), 0 2px 4px 0 rgb(0 0 0 / 2%);
}

.timeline .listing:before {
    content: '';
    background-color: rgba(65, 0, 153, .5);
    ;
    position: absolute;
    bottom: -10px;
    top: -8px;
    left: -21px;
    width: 3px;
}

.timeline .listing:first-child::before {
    top: 50%;
}

.timeline .listing:last-child::before {
    bottom: 50%;
}

.timeline .listing:after {
    content: '●';
    color: #41009a;
    border-radius: 50% 50% 50% 50%;
    border: 1px solid rgba(65, 0, 153, .5);
    background-color: rgba(65, 0, 153, .1) !important;
    position: absolute;
    left: -34px;
    top: 2px;
    height: 28px;
    width: 28px;
    top: 50%;
    transform: translate(0%, -50%);
    text-align: center;
    font-weight: bold;
    padding-top: 2px;
}



.itineraryCardHeader {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f2f2;
}

.itineraryBorderBottom {
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.lessContent {
    transition: max-height 0.5s ease-in-out;
    /* Animasyonu ekliyoruz */
    overflow: hidden;
    max-height: 1000px;

}

.lessContent.shrink {

    max-height: 120px;
    /* Animasyonla düşüreceğimiz değer */
}

.lessContentBg {
    width: 100%;
    height: 75px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 99%, rgba(255, 255, 255, 1) 100%);
    position: absolute;
    bottom: 50px;
    border-bottom: 1px solid #f2f2f2;

}

.maps {
    width: 100%;
    height: 400px;
    margin-top: 15px;
    border-radius: 7px;
}


.mapButtonSet {
    position: absolute;
    width: 50%;
    bottom: 0px;
    left: 25%;
}



.mapButtonSet .buttonContainer {
    border-radius: 7px 7px 0px 0px;
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    padding-top: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
    margin-right: auto;
    margin-left: auto;
    background-color: white;
    box-shadow: 1px 0px 2px 0 rgb(0 0 0 / 3%), 0 -1px 6px -1px rgb(0 0 0 / 2%), 0 -2px 4px 0 rgb(0 0 0 / 2%);
}


.mediaButtonSet {
    display: flex;
}

.file-upload {
    height: 50px;
    width: 100%;
    border-radius: 7px;
    border: 3px dashed #dedede;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #fff;
    color: #666;
    font-size: 20px;
    text-align: center;
    margin-bottom: 15px;
    margin-right: 15px;
}

.file-upload input[type=file] {

    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
}


.previewLink {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    display: inherit;
}

.uploadButtonText {
    padding: 0 !important;
    margin: 0 !important;
    line-height: 0 !important;
    margin-left: 4px !important;
}

.loadingContent {
    position: absolute;
    background: rgba(255, 255, 255, 0.8);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 7px;
    z-index: 11;
}

.loadingContent .loadIcon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
}


.mediaButtonSet {
    display: flex;
}

.mediaButtonSet>div {
    display: flex;
    height: 80px;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    color: white
}

.mediaButtonSet .delete {
    background-color: #ff000080;
}

.mediaButtonSet .move {
    background-color: #40009a41;
    border-left: 1px solid #dedede;
    border-radius: 0px 7px 7px 0px;
}

.packageTabs .ant-tabs-left >.ant-tabs-nav .ant-tabs-tab+.ant-tabs-tab {
    margin: 0 !important;
}

.schedule .ant-tabs-tabpane {
    padding: 0 !important;
}

.schedule .ant-tabs-tab:first-child {
    margin-top: 15px;
}

.schedule .ant-tabs-tab+.ant-tabs-tab {
    margin-top: 0px!important;
}

.schedule .ant-tabs-content {
    min-height: calc(100vh - 60px);
}

.InformationIcon {
    position: absolute;
    top: -7px;
    right: -5px;
    border: 1px solid;
    border-radius: 50%;
    padding-left: 4px;
    padding-right: 4px;
    /* background-color: gray; */
    background-color: #e6f4ff;
    border: 1px solid #91caff;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
}
.InformationIconRelative {
    border: 1px solid;
    border-radius: 50%;
    padding-left: 4px;
    padding-right: 4px;
    /* background-color: gray; */
    background-color: #e6f4ff;
    border: 1px solid #91caff;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    margin-left: 5px;
}

@keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
      background-color: #f2f2f2;
    }
    to {
      opacity: 1;
      transform: translateY(0);
      background-color: #ffffff;
    }
  }
  
  .newItemPrice {
    animation: fadeIn 0.5s ease-out;
    background-color: #f2f2f2;
  }

  @keyframes addedIn {
    from {
      opacity: 1;
      transform: translateY(-10px);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }
  
  .newItemPriceBadge {
    opacity: 0;
    transform: translateY(-10px);
    animation: addedIn 1.0s ease-in;
    animation-fill-mode: forwards;
    animation-delay: 1s;
  }

  .packageModules .ant-menu-dark.ant-menu-inline .ant-menu-item {
    padding-left: 10px !important;
  }

  .ant-tabs-dropdown {
    z-index: 99999999 !important;
  }`, "",{"version":3,"sources":["webpack://./src/Assets/css/layouts.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,yBAAyB;IACzB,oCAAoC;IACpC,eAAe;IACf,qBAAqB;IACrB,WAAW;AACf;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;;IAEI,eAAe;;AAEnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IAIzB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;;iDAEiD;;AAEjD;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,2DAA2D;AAC/D;;AAEA,oBAAoB;AACpB;IACI,wEAAwE;IACxE,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,uFAAuF;AAC3F;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8EAA8E;AAClF;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iDAAiD;IACjD,6BAA6B;IAC7B,qBAAqB;IACrB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA,mBAAmB;AACnB;;IAEI,gDAAgD;IAChD,sDAAsD;IACtD,8BAA8B;IAC9B,iCAAiC;IACjC,wBAAwB;IACxB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yFAAyF;IACzF,+CAA+C;AACnD;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,kCAAkC;IAClC,SAAO;AACX;;AAEA;;IAEI,8BAA8B;IAC9B,wBAAwB;IACxB,uBAAuB;IACvB,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mGAAmG;IACnG,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;;IAEI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;IAChC,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,uFAAuF;AAC3F;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;;IAEI,kCAAkC;IAClC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA,sBAAsB;AACtB;IACI,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,4CAA4C;AAChD;;AAEA;IACI;QACI,uBAAuB;QACvB,wBAAwB;QACxB,mBAAmB;IACvB;AACJ;;AAEA,qBAAqB;AACrB;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,uCAAuC;IACvC,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,+CAA+C;AACnD;;AAEA;IACI,uCAAuC;IACvC,mCAAmC;AACvC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAuDC;;AAED;IACI,0BAA0B;;AAE9B;;AAEA;IACI,oBAAoB;;AAExB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA,cAAc;;AAEd;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,yBAAyB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,MAAM;;IAEN,mBAAmB;;;AAGvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA,GAAG;AACH;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;;AAErB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;;AAGA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oGAAoG;AACxG;;AAEA;IACI,WAAW;IACX,sCAAsC;;IAEtC,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,WAAW;IACX,UAAU;AACd;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,sCAAsC;IACtC,iDAAiD;IACjD,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;;;AAIA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;;IAEI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0HAA0H;IAC1H,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;;AAEpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;AACb;;;;AAIA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,wGAAwG;AAC5G;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAElB,aAAa;IAEb,uBAAuB;IAEvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,eAAe;IACf,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;IAEvB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;MACE,UAAU;MACV,4BAA4B;MAC5B,yBAAyB;IAC3B;IACA;MACE,UAAU;MACV,wBAAwB;MACxB,yBAAyB;IAC3B;EACF;;EAEA;IACE,+BAA+B;IAC/B,yBAAyB;EAC3B;;EAEA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,2BAA2B;IAC7B;EACF;;EAEA;IACE,UAAU;IACV,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B","sourcesContent":[".layout .left .companyInfo {\r\n    border-bottom: 1px solid #dedede;\r\n    border-top: 1px solid #dedede;\r\n    padding-left: 13px;\r\n    padding-right: 5px;\r\n    padding-top: 15px;\r\n    padding-bottom: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    align-content: space-around;\r\n    color: #dedede;\r\n    background-color: #273643;\r\n}\r\n\r\n.layout .left .companyInfo .avatar {\r\n    width: 25%;\r\n    border-radius: 50%;\r\n}\r\n\r\n.layout .left .companyInfo .avatar img {\r\n    border-radius: 50%;\r\n    width: 53px;\r\n    border: 2px solid #dedede;\r\n    background-color: #fff;\r\n}\r\n\r\n.layout .left .companyInfo .infos {\r\n    width: 75%;\r\n    padding-left: 15px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.layout .left .companyInfo .infos .nameSurname {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: white;\r\n}\r\n\r\n.layout .left .companyInfo .infos .companyName {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: white;\r\n}\r\n\r\n.layout a:link {\r\n    text-decoration: none;\r\n}\r\n\r\n.layout .ant-menu-item-selected {\r\n    background-color: #1677ff;\r\n    border-radius: 0 !important;\r\n}\r\n\r\n.trigger {\r\n\r\n    font-size: 18px;\r\n    line-height: 64px;\r\n    cursor: pointer;\r\n    transition: color 0.3s;\r\n}\r\n\r\n.ant-menu-title-content>a {\r\n    color: hsl(0, 0%, 90%) !important;\r\n    text-decoration: none;\r\n}\r\n\r\n#FIXED_CONTAINER_ID>div {\r\n    z-index: 999999 !important;\r\n}\r\n\r\n.ant-spin-fullscreen-show {\r\n    z-index: 999999 !important;\r\n}\r\n\r\n.cardSelect {\r\n    box-shadow: 0 0 10px -2px rgb(0 0 0 / 20%);\r\n    border-radius: 5px;\r\n    transition: transform .2s;\r\n    cursor: pointer;\r\n}\r\n\r\n.cardSelect:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.cardSelected {\r\n    box-shadow: 0 0 10px -2px rgb(0 0 0 / 40%);\r\n    border-radius: 5px;\r\n    transition: transform .2s;\r\n    border: 3px solid #41009a !important;\r\n    cursor: pointer;\r\n    transform: scale(1.2);\r\n    z-index: 99;\r\n}\r\n\r\n\r\n.ant-table-header col {\r\n    min-width: 120px;\r\n}\r\n\r\n.ant-table-body td {\r\n    min-width: 120px;\r\n\r\n}\r\n\r\n.ant-table-body td:first-child,\r\n.ant-table-body td:nth-child(2) {\r\n    min-width: 40px;\r\n\r\n}\r\n\r\n.ant-table-header col:first-child,\r\n.ant-table-header col:nth-child(2) {\r\n    min-width: 40px;\r\n}\r\n\r\n.listingManifest {\r\n    margin-bottom: 3px;\r\n    border: 1px solid #ccc;\r\n    padding-top: 3px;\r\n    padding-bottom: 3px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 0px;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\nsvg {\r\n    vertical-align: baseline !important;\r\n}\r\n\r\n.showHidePassword {\r\n    position: absolute;\r\n    top: 14px;\r\n    right: 15px;\r\n    cursor: pointer;\r\n}\r\n\r\n.loginPage .or {\r\n    border-bottom: 1px solid #e8e8e8;\r\n    line-height: .1em;\r\n    margin: 15px 0;\r\n    text-align: center\r\n}\r\n\r\n.loginPage .or span {\r\n    background: #fff;\r\n    color: #999;\r\n    padding: 0 10px\r\n}\r\n\r\n.layouts .title {\r\n    width: 100%;\r\n    font-size: 12px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.layouts .company {\r\n    width: 100%;\r\n    font-size: 11px;\r\n    font-weight: bold;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n\r\n}\r\n\r\n/* ============================================\r\n   BONUS / KHG LAYOUT THEME\r\n   ============================================ */\r\n\r\n:root {\r\n    --bonus-gold: #c8a96a;\r\n    --bonus-gold-light: #e0c48a;\r\n    --bonus-gold-dark: #a8884a;\r\n    --bonus-ink: #1f2937;\r\n    --bonus-ink-soft: #4b5563;\r\n    --bonus-bg: #f7f5f0;\r\n}\r\n\r\n.bonus-shell {\r\n    background: var(--bonus-bg) !important;\r\n    font-family: 'Roboto', system-ui, -apple-system, sans-serif;\r\n}\r\n\r\n/* ---- Sider ---- */\r\n.bonus-sider {\r\n    background: linear-gradient(180deg, #0f1620 0%, #0b1018 100%) !important;\r\n    box-shadow: 4px 0 24px rgba(15, 22, 32, 0.06);\r\n}\r\n\r\n.bonus-sider .ant-layout-sider-children {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.bonus-sider-logo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    padding: 22px 18px 20px;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n    position: relative;\r\n}\r\n\r\n.bonus-sider-logo::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 18px;\r\n    right: 18px;\r\n    height: 1px;\r\n    background: linear-gradient(90deg, transparent, rgba(200, 169, 106, 0.35), transparent);\r\n}\r\n\r\n.bonus-sider-logo.collapsed {\r\n    padding: 22px 0 20px;\r\n    justify-content: center;\r\n}\r\n\r\n.bonus-sider-logo-mark {\r\n    flex-shrink: 0;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 11px;\r\n    background: #fff;\r\n    padding: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(200, 169, 106, 0.4);\r\n}\r\n\r\n.bonus-sider-logo-mark img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.bonus-sider-logo-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    line-height: 1.05;\r\n}\r\n\r\n.bonus-sider-logo-title {\r\n    font-size: 22px;\r\n    font-weight: 700;\r\n    background: linear-gradient(90deg, #fff, #e0c48a);\r\n    -webkit-background-clip: text;\r\n    background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.bonus-sider-logo-sub {\r\n    font-size: 10.5px;\r\n    color: var(--bonus-gold-light);\r\n    text-transform: uppercase;\r\n    letter-spacing: 1.5px;\r\n    margin-top: 4px;\r\n    opacity: 0.8;\r\n}\r\n\r\n/* User info card */\r\n.layouts .companyInfo,\r\n.bonus-sider-user {\r\n    background: rgba(255, 255, 255, 0.03) !important;\r\n    border: 1px solid rgba(255, 255, 255, 0.06) !important;\r\n    border-radius: 12px !important;\r\n    margin: 16px 14px 12px !important;\r\n    padding: 12px !important;\r\n    color: rgba(255, 255, 255, 0.88) !important;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.bonus-sider-avatar {\r\n    background: linear-gradient(135deg, var(--bonus-gold), var(--bonus-gold-dark)) !important;\r\n    box-shadow: 0 4px 12px rgba(200, 169, 106, 0.3);\r\n}\r\n\r\n.bonus-sider-user-name {\r\n    font-size: 13.5px !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.bonus-sider-user-meta {\r\n    font-size: 11px !important;\r\n    color: rgba(255, 255, 255, 0.55) !important;\r\n    font-weight: 500 !important;\r\n}\r\n\r\n/* Status badge */\r\n.bonus-sider-status {\r\n    margin: 0 14px 16px;\r\n}\r\n\r\n.bonus-status-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    width: 100%;\r\n    justify-content: center;\r\n    padding: 7px 12px;\r\n    border-radius: 999px;\r\n    font-size: 11.5px;\r\n    font-weight: 600;\r\n    letter-spacing: 0.4px;\r\n}\r\n\r\n.bonus-status-badge .dot {\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n    box-shadow: 0 0 0 3px currentColor;\r\n    opacity: 0.25;\r\n}\r\n\r\n.bonus-status-badge.approved {\r\n    background: rgba(200, 169, 106, 0.14);\r\n    color: var(--bonus-gold-light);\r\n    border: 1px solid rgba(200, 169, 106, 0.3);\r\n}\r\n\r\n.bonus-status-badge.approved .dot {\r\n    background: var(--bonus-gold);\r\n    color: var(--bonus-gold);\r\n}\r\n\r\n.bonus-status-badge.pending {\r\n    background: rgba(250, 204, 21, 0.1);\r\n    color: #facc15;\r\n    border: 1px solid rgba(250, 204, 21, 0.3);\r\n}\r\n\r\n.bonus-status-badge.pending .dot {\r\n    background: #facc15;\r\n    color: #facc15;\r\n}\r\n\r\n/* Menu */\r\n.bonus-sider-menu {\r\n    border-inline-end: 0 !important;\r\n    padding: 6px 10px !important;\r\n    background: transparent !important;\r\n    flex: 1;\r\n}\r\n\r\n.bonus-sider-menu .ant-menu-item,\r\n.bonus-sider-menu .ant-menu-submenu-title {\r\n    border-radius: 10px !important;\r\n    margin: 4px 0 !important;\r\n    height: 42px !important;\r\n    line-height: 42px !important;\r\n    font-size: 13.5px;\r\n    font-weight: 500;\r\n}\r\n\r\n.bonus-sider-menu .ant-menu-item-selected {\r\n    background: linear-gradient(90deg, rgba(200, 169, 106, 0.22), rgba(200, 169, 106, 0.08)) !important;\r\n    border-left: 2px solid var(--bonus-gold);\r\n    padding-left: calc(24px - 2px) !important;\r\n}\r\n\r\n.bonus-sider-menu .ant-menu-item-selected .ant-menu-title-content > a,\r\n.bonus-sider-menu .ant-menu-item-selected .ant-menu-title-content {\r\n    color: var(--bonus-gold-light) !important;\r\n    font-weight: 600;\r\n}\r\n\r\n.bonus-sider-menu .ant-menu-item .anticon,\r\n.bonus-sider-menu .ant-menu-submenu-title .anticon {\r\n    font-size: 16px !important;\r\n}\r\n\r\n.layouts .ant-menu-item-selected {\r\n    background-color: transparent;\r\n}\r\n\r\n.ant-menu-title-content > a {\r\n    color: rgba(255, 255, 255, 0.78) !important;\r\n}\r\n\r\n.bonus-sider-menu .ant-menu-item:hover .ant-menu-title-content > a {\r\n    color: #fff !important;\r\n}\r\n\r\n/* ---- Header ---- */\r\n.bonus-header {\r\n    padding: 0 24px !important;\r\n    background: #fff !important;\r\n    height: 68px !important;\r\n    line-height: 68px !important;\r\n    display: flex !important;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n    border-bottom: 1px solid #ece8dd;\r\n    box-shadow: 0 2px 12px rgba(31, 41, 55, 0.04);\r\n    position: relative;\r\n}\r\n\r\n.bonus-header::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -1px;\r\n    left: 0;\r\n    right: 0;\r\n    height: 1px;\r\n    background: linear-gradient(90deg, transparent, rgba(200, 169, 106, 0.45), transparent);\r\n}\r\n\r\n.bonus-header-search {\r\n    flex: 1;\r\n    max-width: 480px;\r\n    background: #f7f5f0;\r\n    border-radius: 999px;\r\n    padding: 0 8px 0 14px;\r\n    height: 42px;\r\n    display: flex;\r\n    align-items: center;\r\n    border: 1px solid transparent;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.bonus-header-search:focus-within {\r\n    border-color: var(--bonus-gold);\r\n    background: #fff;\r\n    box-shadow: 0 0 0 3px rgba(200, 169, 106, 0.15);\r\n}\r\n\r\n.bonus-header-search-input.ant-input,\r\n.bonus-header-search-input .ant-input {\r\n    background: transparent !important;\r\n    font-size: 13.5px;\r\n    line-height: 1;\r\n}\r\n\r\n.bonus-header-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n}\r\n\r\n.bonus-header-icon-btn {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 10px;\r\n    background: #f7f5f0;\r\n    border: 0;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.bonus-header-icon-btn:hover {\r\n    background: #ece8dd;\r\n}\r\n\r\n.bonus-header-divider {\r\n    width: 1px;\r\n    height: 28px;\r\n    background: #ece8dd;\r\n}\r\n\r\n.bonus-header-user {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 4px 10px 4px 4px;\r\n    border-radius: 999px;\r\n    cursor: pointer;\r\n    transition: background 0.2s ease;\r\n}\r\n\r\n.bonus-header-user:hover {\r\n    background: #f7f5f0;\r\n}\r\n\r\n.bonus-header-avatar {\r\n    background: linear-gradient(135deg, var(--bonus-gold), var(--bonus-gold-dark)) !important;\r\n}\r\n\r\n.bonus-header-user-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    line-height: 1.15;\r\n}\r\n\r\n.bonus-header-user-text strong {\r\n    font-size: 13px;\r\n    color: var(--bonus-ink);\r\n    font-weight: 600;\r\n}\r\n\r\n.bonus-header-user-text small {\r\n    font-size: 11px;\r\n    color: var(--bonus-ink-soft);\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n    .bonus-header {\r\n        padding: 0 14px !important;\r\n    }\r\n    .bonus-header-search {\r\n        display: none;\r\n    }\r\n    .bonus-header-user-text {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* ---- Content ---- */\r\n.bonus-content {\r\n    margin: 24px !important;\r\n    padding: 28px !important;\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    box-shadow: 0 4px 20px rgba(31, 41, 55, 0.04);\r\n    min-height: calc(100vh - 68px - 56px - 48px);\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n    .bonus-content {\r\n        margin: 12px !important;\r\n        padding: 16px !important;\r\n        border-radius: 10px;\r\n    }\r\n}\r\n\r\n/* ---- Footer ---- */\r\n.bonus-footer {\r\n    text-align: center !important;\r\n    padding: 16px 24px !important;\r\n    color: var(--bonus-ink-soft) !important;\r\n    background: var(--bonus-bg) !important;\r\n    font-size: 12.5px;\r\n}\r\n\r\n.bonus-footer strong {\r\n    color: var(--bonus-gold-dark);\r\n    font-weight: 700;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n/* Sider trigger (collapse button) */\r\n.bonus-sider .ant-layout-sider-trigger {\r\n    background: #0a1119 !important;\r\n    color: var(--bonus-gold) !important;\r\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\r\n}\r\n\r\n.ant-layout-sider-zero-width-trigger {\r\n    background: var(--bonus-ink) !important;\r\n    color: var(--bonus-gold) !important;\r\n}\r\n/*\r\n.ant-slider-horizontal .ant-slider-step {\r\n    height: 15px !important;\r\n    inset-inline-start: 0;\r\n    top: 15px;\r\n    width: 100%\r\n}\r\n\r\n.ant-slider-horizontal {\r\n    height: 50px !important;\r\n    padding-block: 4px\r\n}\r\n\r\n.ant-slider .ant-slider-handle:active:after,\r\n.ant-slider .ant-slider-handle:focus:after,\r\n.ant-slider-handle:hover:after {\r\n    box-shadow: 0 0 0 4px #410099 !important;\r\n    height: 25px !important;\r\n    width: 25px !important;\r\n}\r\n\r\n.ant-slider .ant-slider-handle:after {\r\n    box-shadow: 0 0 0 4px #410099 !important\r\n}\r\n\r\n.ant-slider-dot-active {\r\n    border-color: #410099 !important\r\n}\r\n\r\n.ant-slider .ant-slider-handle:after,\r\n.ant-slider-handle:before {\r\n    height: 25px !important;\r\n    width: 25px !important\r\n}\r\n\r\n.ant-slider-handle:before {\r\n    background-color: initial;\r\n    content: \"\";\r\n    inset-block-start: -2px;\r\n    inset-inline-start: -2px;\r\n    position: absolute\r\n}\r\n\r\n.ant-slider-horizontal .ant-slider-mark {\r\n    inset-inline-start: 0;\r\n    top: 30px !important;\r\n    width: 100%\r\n}\r\n\r\n.ant-slider-handle {\r\n    height: 25px !important;\r\n    outline: none;\r\n    position: absolute;\r\n    width: 25px !important\r\n}\r\n*/\r\n\r\n.appstore .ant-tabs-tab {\r\n    padding-left: 0 !important;\r\n\r\n}\r\n\r\n.ant-layout-sider-zero-width-trigger {\r\n    top: 12px !important;\r\n    ;\r\n}\r\n\r\n.ant-tabs .ant-tabs-tab-btn {\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n.ant-collapse-item-disabled>.ant-collapse-header {\r\n    cursor: default !important;\r\n}\r\n\r\n/*wizard step*/\r\n\r\n.steps .stepsLabel {\r\n    border-bottom: 1px solid #dedede;\r\n    color: #1a335399;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    line-height: 1.5;\r\n    margin-bottom: 15px;\r\n    margin-top: 15px;\r\n    padding: 12px 15px;\r\n    text-transform: uppercase\r\n}\r\n\r\n.steps ul {\r\n    list-style-type: none;\r\n    padding-left: 20px\r\n}\r\n\r\n.steps ul li {\r\n    -webkit-font-smoothing: antialiased;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    display: flex;\r\n    font-size: 14px;\r\n    height: 40px;\r\n    padding-bottom: 4px;\r\n    padding-left: 15px;\r\n    padding-top: 4px;\r\n    position: relative;\r\n    text-rendering: optimizeLegibility\r\n}\r\n\r\n.steps ul li.actives {\r\n    background-color: #4100991a !important;\r\n    border-left: 3px solid #410099;\r\n    color: #410099 !important;\r\n    text-decoration: none\r\n}\r\n\r\n.steps ul li.completes {\r\n    color: #333 !important;\r\n    text-decoration: none\r\n}\r\n\r\n.steps ul li.completes:after {\r\n    color: #410099 !important;\r\n    content: \"✓\";\r\n    position: absolute;\r\n    right: 15px\r\n}\r\n\r\n.steps ul li.passive {\r\n    color: #a1a1a1;\r\n    text-decoration: line-through\r\n}\r\n\r\n.products {\r\n    align-items: center;\r\n    display: flex\r\n}\r\n\r\n.products .img {\r\n\r\n    padding-right: 15px\r\n}\r\n\r\n.products .img img {\r\n    border-radius: 5px;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    width: 120px\r\n}\r\n\r\n.products .prog {\r\n    padding-left: 15px\r\n}\r\n\r\n.products .detail {\r\n    border-left: 1px solid #dedede;\r\n    margin-left: 15px;\r\n    padding-left: 15px\r\n}\r\n\r\n.products .detail .categories {\r\n    margin-bottom: 5px\r\n}\r\n\r\n.products .detail .recordDate {\r\n    color: #999;\r\n    font-size: 12px\r\n}\r\n\r\n\r\n.inputButtonSet {\r\n    display: flex;\r\n    position: absolute;\r\n    right: 0;\r\n    height: 58px;\r\n    top: 0;\r\n\r\n    align-items: center;\r\n\r\n\r\n}\r\n\r\n.inputButtonSet>div {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    height: 58px;\r\n    align-items: center;\r\n    display: flex;\r\n    background-color: #40009a15;\r\n    cursor: pointer;\r\n}\r\n\r\n.inputButtonSet>div:hover {\r\n    background-color: #40009a41;\r\n}\r\n\r\n.inputButtonSet>div:last-child {\r\n    border-left: 1px solid #dedede;\r\n    border-bottom-right-radius: 7px;\r\n    border-top-right-radius: 7px;\r\n}\r\n\r\n/**/\r\n.ant-tree {\r\n    background-color: transparent;\r\n}\r\n\r\n.dotArea {\r\n    position: relative;\r\n    border: 2px dashed #dedede;\r\n    padding: 20px 20px 20px 20px;\r\n    background-color: #0505050f;\r\n    border-radius: 7px;\r\n    min-height: 56px;\r\n}\r\n\r\n.autocompleteContainer li:first-child {\r\n    border-top: 0;\r\n    border-radius: 0;\r\n\r\n}\r\n\r\n.autocompleteContainer li:last-child {\r\n    border-bottom: 0;\r\n    border-radius: 0;\r\n}\r\n\r\n.autocompleteContainer li {\r\n    border-left: 0;\r\n    border-right: 0;\r\n    font-size: 13px;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n.autocompleteContainer li span::before {\r\n    content: '◉';\r\n    margin-right: 5px;\r\n\r\n}\r\n\r\n.autocompleteContainer li .noResult {\r\n    content: '';\r\n    color: #ff0000;\r\n    margin-right: 5px;\r\n\r\n}\r\n\r\n.autocompleteContainer li .noResult::before {\r\n\r\n    content: '';\r\n    color: #ff0000;\r\n    margin-right: 5px;\r\n\r\n}\r\n\r\n.autocompleteContainer li:hover {\r\n    background-color: #f2f2f2;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.itineraryCardHeader {\r\n    width: 100%;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    padding-top: 15px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #f2f2f2;\r\n}\r\n\r\n.itineraryBorderBottom {\r\n    border-bottom: 1px solid #f2f2f2;\r\n    padding-bottom: 15px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n\r\n.itineraryCardBody {\r\n    padding: 20px\r\n}\r\n\r\n.timeline {\r\n    position: relative;\r\n    margin: 0;\r\n    padding: 0;\r\n    list-style: none;\r\n}\r\n\r\n.timeline .list-group-item+.list-group-item {\r\n    border-top-width: 1px !important;\r\n}\r\n\r\n.timeline .listing {\r\n    position: relative;\r\n    margin-left: 20px;\r\n    border: 1px solid #f2f2f2;\r\n    background-color: #f9f9f9;\r\n    border-radius: 7px;\r\n    padding: 15px;\r\n    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 3%), 0 1px 6px -1px rgb(0 0 0 / 2%), 0 2px 4px 0 rgb(0 0 0 / 2%);\r\n}\r\n\r\n.timeline .listing:before {\r\n    content: '';\r\n    background-color: rgba(65, 0, 153, .5);\r\n    ;\r\n    position: absolute;\r\n    bottom: -10px;\r\n    top: -8px;\r\n    left: -21px;\r\n    width: 3px;\r\n}\r\n\r\n.timeline .listing:first-child::before {\r\n    top: 50%;\r\n}\r\n\r\n.timeline .listing:last-child::before {\r\n    bottom: 50%;\r\n}\r\n\r\n.timeline .listing:after {\r\n    content: '●';\r\n    color: #41009a;\r\n    border-radius: 50% 50% 50% 50%;\r\n    border: 1px solid rgba(65, 0, 153, .5);\r\n    background-color: rgba(65, 0, 153, .1) !important;\r\n    position: absolute;\r\n    left: -34px;\r\n    top: 2px;\r\n    height: 28px;\r\n    width: 28px;\r\n    top: 50%;\r\n    transform: translate(0%, -50%);\r\n    text-align: center;\r\n    font-weight: bold;\r\n    padding-top: 2px;\r\n}\r\n\r\n\r\n\r\n.itineraryCardHeader {\r\n    width: 100%;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    padding-top: 15px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 1px solid #f2f2f2;\r\n}\r\n\r\n.itineraryBorderBottom {\r\n    border-bottom: 1px solid #f2f2f2;\r\n    padding-bottom: 15px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.lessContent {\r\n    transition: max-height 0.5s ease-in-out;\r\n    /* Animasyonu ekliyoruz */\r\n    overflow: hidden;\r\n    max-height: 1000px;\r\n\r\n}\r\n\r\n.lessContent.shrink {\r\n\r\n    max-height: 120px;\r\n    /* Animasyonla düşüreceğimiz değer */\r\n}\r\n\r\n.lessContentBg {\r\n    width: 100%;\r\n    height: 75px;\r\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 99%, rgba(255, 255, 255, 1) 100%);\r\n    position: absolute;\r\n    bottom: 50px;\r\n    border-bottom: 1px solid #f2f2f2;\r\n\r\n}\r\n\r\n.maps {\r\n    width: 100%;\r\n    height: 400px;\r\n    margin-top: 15px;\r\n    border-radius: 7px;\r\n}\r\n\r\n\r\n.mapButtonSet {\r\n    position: absolute;\r\n    width: 50%;\r\n    bottom: 0px;\r\n    left: 25%;\r\n}\r\n\r\n\r\n\r\n.mapButtonSet .buttonContainer {\r\n    border-radius: 7px 7px 0px 0px;\r\n    position: relative;\r\n    width: fit-content;\r\n    padding-top: 15px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    padding-bottom: 10px;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    background-color: white;\r\n    box-shadow: 1px 0px 2px 0 rgb(0 0 0 / 3%), 0 -1px 6px -1px rgb(0 0 0 / 2%), 0 -2px 4px 0 rgb(0 0 0 / 2%);\r\n}\r\n\r\n\r\n.mediaButtonSet {\r\n    display: flex;\r\n}\r\n\r\n.file-upload {\r\n    height: 50px;\r\n    width: 100%;\r\n    border-radius: 7px;\r\n    border: 3px dashed #dedede;\r\n    position: relative;\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    -webkit-justify-content: center;\r\n    justify-content: center;\r\n    -webkit-align-items: center;\r\n    align-items: center;\r\n    overflow: hidden;\r\n    background-color: #fff;\r\n    color: #666;\r\n    font-size: 20px;\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n    margin-right: 15px;\r\n}\r\n\r\n.file-upload input[type=file] {\r\n\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    z-index: 10;\r\n}\r\n\r\n\r\n.previewLink {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n\r\n    display: inherit;\r\n}\r\n\r\n.uploadButtonText {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    line-height: 0 !important;\r\n    margin-left: 4px !important;\r\n}\r\n\r\n.loadingContent {\r\n    position: absolute;\r\n    background: rgba(255, 255, 255, 0.8);\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    border-radius: 7px;\r\n    z-index: 11;\r\n}\r\n\r\n.loadingContent .loadIcon {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.mediaButtonSet {\r\n    display: flex;\r\n}\r\n\r\n.mediaButtonSet>div {\r\n    display: flex;\r\n    height: 80px;\r\n    align-items: center;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    color: white\r\n}\r\n\r\n.mediaButtonSet .delete {\r\n    background-color: #ff000080;\r\n}\r\n\r\n.mediaButtonSet .move {\r\n    background-color: #40009a41;\r\n    border-left: 1px solid #dedede;\r\n    border-radius: 0px 7px 7px 0px;\r\n}\r\n\r\n.packageTabs .ant-tabs-left >.ant-tabs-nav .ant-tabs-tab+.ant-tabs-tab {\r\n    margin: 0 !important;\r\n}\r\n\r\n.schedule .ant-tabs-tabpane {\r\n    padding: 0 !important;\r\n}\r\n\r\n.schedule .ant-tabs-tab:first-child {\r\n    margin-top: 15px;\r\n}\r\n\r\n.schedule .ant-tabs-tab+.ant-tabs-tab {\r\n    margin-top: 0px!important;\r\n}\r\n\r\n.schedule .ant-tabs-content {\r\n    min-height: calc(100vh - 60px);\r\n}\r\n\r\n.InformationIcon {\r\n    position: absolute;\r\n    top: -7px;\r\n    right: -5px;\r\n    border: 1px solid;\r\n    border-radius: 50%;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    /* background-color: gray; */\r\n    background-color: #e6f4ff;\r\n    border: 1px solid #91caff;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.InformationIconRelative {\r\n    border: 1px solid;\r\n    border-radius: 50%;\r\n    padding-left: 4px;\r\n    padding-right: 4px;\r\n    /* background-color: gray; */\r\n    background-color: #e6f4ff;\r\n    border: 1px solid #91caff;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    margin-left: 5px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n      transform: translateY(-10px);\r\n      background-color: #f2f2f2;\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n      background-color: #ffffff;\r\n    }\r\n  }\r\n  \r\n  .newItemPrice {\r\n    animation: fadeIn 0.5s ease-out;\r\n    background-color: #f2f2f2;\r\n  }\r\n\r\n  @keyframes addedIn {\r\n    from {\r\n      opacity: 1;\r\n      transform: translateY(-10px);\r\n    }\r\n    to {\r\n      opacity: 0;\r\n      transform: translateY(20px);\r\n    }\r\n  }\r\n  \r\n  .newItemPriceBadge {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n    animation: addedIn 1.0s ease-in;\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 1s;\r\n  }\r\n\r\n  .packageModules .ant-menu-dark.ant-menu-inline .ant-menu-item {\r\n    padding-left: 10px !important;\r\n  }\r\n\r\n  .ant-tabs-dropdown {\r\n    z-index: 99999999 !important;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
